module.exports = __webpack_public_path__ + "img/extended.bcee30ce.png";